import { gql, QueryHookOptions } from '@apollo/client';
import { MessageMedium } from 'constants/messageMediums';
import { useGraphql } from 'utils/hooks/useGraphql';

const GET_TEMPLATE = gql`
  query GetTemplate($id: Long!) {
    template(id: $id) {
      id
      name
      messageMedium
   }
 }`;

interface Template {
  template: {
    id: string;
    name: string;
    messageMedium: MessageMedium;
  };
}

export const useGetTemplate = (options: QueryHookOptions) => {
  const { data, isLoading } = useGraphql<Template>(GET_TEMPLATE, options);

  return {
    template: data?.template,
    isLoading,
  };
};
